import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalAutomationRoute: InvariantJiraRoute = {
	name: 'global-automation',
	path: '/secure/Automation([!%]?[\\w]*).jspa',
};
